module.exports = __webpack_public_path__ + "static/img/logoIcon.2a46fc3c.png";